import { useState, useRef, useEffect } from "react";
import { categories } from "@/mocks/categories";

export default function HeroSection() {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(e: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleCategorySelect = (url: string) => {
    setDropdownOpen(false);
    window.open(url, "_blank", "noopener,nofollow");
  };

  return (
    <section className="relative w-full min-h-[580px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Premium%20fashion%20boutique%20interior%20display%20with%20elegant%20clothing%20racks%2C%20designer%20sneakers%20on%20shelves%2C%20leather%20bags%20and%20accessories%20arranged%20artfully%2C%20warm%20ambient%20lighting%20with%20soft%20golden%20glow%2C%20minimalist%20modern%20retail%20space%20with%20cream%20and%20beige%20tones%2C%20no%20people%2C%20editorial%20interior%20photography%20with%20shallow%20depth%20of%20field&width=1600&height=900&seq=gtbuy-hero-fashion&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40" />

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 py-16 md:py-20 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-white/30 bg-white/10 backdrop-blur-sm mb-6 md:mb-8">
          <span className="w-2 h-2 rounded-full bg-accent-400"></span>
          <span className="text-xs md:text-sm font-medium text-white/90">Spreadsheet Shopping Guide 2026</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-4 md:mb-6">
          GTBuy Spreadsheet Explained
          <br />
          <span className="text-white/80 font-normal text-2xl md:text-4xl lg:text-5xl">
            Compare Kakobuy &amp; Superbuy Systems
          </span>
        </h1>

        <p className="text-sm md:text-lg text-white/75 max-w-2xl mx-auto mb-8 md:mb-10 leading-relaxed">
          Discover how spreadsheet shopping platforms work, compare GTBuy Spreadsheet vs Kakobuy Spreadsheet vs Superbuy Spreadsheet, and find the best option in 2026.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 mb-8">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3 bg-accent-500 text-background-50 rounded-full text-sm md:text-base font-semibold hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
          >
            GTBuy Sheet
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-up-line"></i></span>
          </a>

          <div className="relative w-full sm:w-auto" ref={dropdownRef}>
            <button
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="w-full sm:w-auto inline-flex items-center justify-between sm:justify-center gap-3 px-6 py-3 bg-white/95 text-foreground-800 rounded-full text-sm md:text-base font-medium hover:bg-white transition-colors whitespace-nowrap cursor-pointer"
            >
              <span>Browse Categories</span>
              <span className="w-4 h-4 flex items-center justify-center">
                <i className={`text-sm transition-transform ${dropdownOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}`}></i>
              </span>
            </button>

            {dropdownOpen && (
              <div className="absolute top-full mt-2 left-1/2 -translate-x-1/2 w-64 bg-white rounded-xl border border-background-200 overflow-hidden z-50 py-1 max-h-80 overflow-y-auto">
                {categories.map((cat) => (
                  <button
                    key={cat.name}
                    onClick={() => handleCategorySelect(cat.url)}
                    className="w-full text-left px-5 py-3 text-sm text-foreground-700 hover:bg-background-100 hover:text-foreground-900 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </button>
                ))}
              </div>
            )}
          </div>

          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-7 py-3 bg-white/90 text-foreground-800 rounded-full text-sm md:text-base font-semibold hover:bg-white transition-all whitespace-nowrap cursor-pointer border border-white/40"
          >
            Buy It Now
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-shopping-bag-line"></i></span>
          </a>
        </div>

        <p className="text-xs text-white/50">
          Trusted by thousands of spreadsheet shoppers worldwide
        </p>
      </div>
    </section>
  );
}